import styled, { css } from 'styled-components'

export interface LabelStyleProps {
  variant?: 'default' | 'light' | 'dark'
  hasError: boolean
}

export const StyledErrorMessage = styled.span`
  display: block;
  font-size: 0.7rem;
  font-weight: 600;
  margin-top: 0.6rem;
  padding-left: 0.6rem;
`

export const StyledTextarea = styled.textarea`
  border: 0;
  border-bottom: 0.5rem solid transparent;
  border-right: 0.5rem solid transparent;
  border-radius: 0.6rem;
  box-shadow: 0 0 0 1.5px red;
  font-size: 0.9rem;
  line-height: 1.2;
  min-height: 10rem;
  outline: 0;
  padding: 1.4rem 0.6rem 0.4rem;
  resize: vertical;
  transition: all 0.2s;
  width: 100%;

  &:placeholder-shown:not(:focus) + span {
    font-size: 0.9rem;
    font-weight: 400;
    top: 1rem;
  }

  & + span {
    color: ${({ theme }) => theme.colors.black[1]};
    cursor: text;
    font-size: 0.7rem;
    font-weight: 600;
    left: 0.6rem;
    line-height: 1;
    pointer-events: none;
    position: absolute;
    top: 0.5rem;
    transition: all 0.2s;
  }
`

export const StyledLabel = styled.label<LabelStyleProps>`
  display: block;
  line-height: 0;
  position: relative;

  // Error message in case of error
  & + ${StyledErrorMessage} {
    ${({ hasError, variant }) =>
    hasError &&
    css`
        color: ${({ theme }) => (variant === 'dark' ? theme.colors.red[4] : theme.colors.red[3])};
      `}
  }

  & > ${StyledTextarea} {
    // Error state
    ${({ hasError, variant }) =>
    hasError &&
    css`
        box-shadow: 0 0 0 1.5px ${({ theme }) => (variant === 'dark' ? theme.colors.red[4] : theme.colors.red[3])} !important;
      `}

    ${({ variant }) => {
    switch (variant) {
      case 'light':
        return css`
            background: ${({ theme }) => theme.colors.white[3]};
            color: ${({ theme }) => theme.colors.black[1]};
            box-shadow: 0 0 0 1.5px ${({ theme }) => theme.colors.white[2]};

            &:hover {
              box-shadow: 0 0 0 1.5px ${({ theme }) => theme.colors.white[1]};
            }

            &:focus {
              box-shadow: 0 0 0 1.5px var(--c-theme-3);
            }

            // Large label
            &:placeholder-shown:not(:focus) + span {
              opacity: 0.6;
            }

            // Small label
            & + span {
              opacity: 0.4;
            }
          `
      case 'dark':
        return css`
            background: rgba(0, 0, 0, 0.1);
            color: ${({ theme }) => theme.colors.white[1]};
            box-shadow: 0 0 0 1.5px ${({ theme }) => theme.colors.white[6]};

            &:hover {
              box-shadow: 0 0 0 1.5px ${({ theme }) => theme.colors.white[4]};

              & + span {
                color: ${({ theme }) => theme.colors.white[3]};
              }
            }

            &:focus {
              box-shadow: 0 0 0 1.5px ${({ theme }) => theme.colors.white[1]};

              & + span {
                color: ${({ theme }) => theme.colors.white[4]};
              }
            }

            // Large label
            &:placeholder-shown:not(:focus) + span {
              color: ${({ theme }) => theme.colors.white[3]};
            }

            // Small label
            & + span {
              color: ${({ theme }) => theme.colors.white[4]};
            }
          `
      default:
        return css`
            background: ${({ theme }) => theme.colors.white[1]};
            color: ${({ theme }) => theme.colors.black[1]};
            box-shadow: 0 0 0 1.5px ${({ theme }) => theme.colors.black[6]};

            &:hover {
              box-shadow: 0 0 0 1.5px ${({ theme }) => theme.colors.black[5]};
            }

            &:focus {
              box-shadow: 0 0 0 1.5px ${({ theme }) => theme.colors.black[1]};
            }

            // Large label
            &:placeholder-shown:not(:focus) + span {
              opacity: 0.6;
            }

            // Small label
            & + span {
              opacity: 0.4;
            }
          `
    }
  }}
  }
`
